// These values are also used for class names
export enum IconButtonSize {
  Small = 'small',
  Medium = 'medium',
}

export enum IconButtonVariant {
  TransparentDark = 'transparentDark',
  TransparentLight = 'transparentLight',
  SolidLight = 'solidLight',
  SolidLightActive = 'solidLightActive',
  Danger = 'danger',
}
